<template>
    <div class="mail-box">
        <div class="mail">
            <div class="row">
                <div class="col-md-12">
                    
                    <form v-if="bid_completed != null" @submit="storeUserAvaliation()">
                        <h2>Avaliar Perito Contratado</h2>
                        <div class="container">

                        <h2 class="font-bold">{{ bid.approved_proposal.expert.user.full_name }}</h2>

                            <div class="rows margin-t">

                                <div class="col-md-3 none-padding">
                                    <h5 class="review-stat">Desempenho</h5>
                                    <ul class="avaliacao">
                                        <li class="star-icon ativo desempenho" data-aval-desem="1" @click="avaliation($event)"></li>
                                        <li class="star-icon desempenho" data-aval-desem="2" @click="avaliation($event)"></li>
                                        <li class="star-icon desempenho" data-aval-desem="3" @click="avaliation($event)"></li>
                                        <li class="star-icon desempenho" data-aval-desem="4" @click="avaliation($event)"></li>
                                        <li class="star-icon desempenho" data-aval-desem="5" @click="avaliation($event)"></li>
                                    </ul>
                                </div>

                                <div class="col-md-3 none-padding">
                                    <h5 class="review-stat">Atendimento</h5>
                                    <ul class="avaliacao">
                                        <li class="star-icon ativo atendimento" data-aval-atend="1" @click="avaliation($event)"></li>
                                        <li class="star-icon atendimento" data-aval-atend="2" @click="avaliation($event)"></li>
                                        <li class="star-icon atendimento" data-aval-atend="3" @click="avaliation($event)"></li>
                                        <li class="star-icon atendimento" data-aval-atend="4" @click="avaliation($event)"></li>
                                        <li class="star-icon atendimento" data-aval-atend="5" @click="avaliation($event)"></li>
                                    </ul>
                                </div>
                                
                                <div class="col-md-3 none-padding">
                                    <h5 class="review-stat">Prazo</h5>
                                    <ul class="avaliacao">
                                        <li class="star-icon ativo prazo" data-aval-prazo="1" @click="avaliation($event)"></li>
                                        <li class="star-icon prazo" data-aval-prazo="2" @click="avaliation($event)"></li>
                                        <li class="star-icon prazo" data-aval-prazo="3" @click="avaliation($event)"></li>
                                        <li class="star-icon prazo" data-aval-prazo="4" @click="avaliation($event)"></li>
                                        <li class="star-icon prazo" data-aval-prazo="5" @click="avaliation($event)"></li>
                                    </ul>
                                </div>
                            
                            </div>

                        </div>

                        <div class="form-group margin-t padding-x">
                            <label for="about">Faça um comentário</label>
                            <textarea class="form-control" id="about" v-model="comments" rows="3"></textarea>
                        </div>
                        <button class="btn btn-primary" type="submit" >Avaliar</button>
                    </form>
                </div>
            </div>
        </div>
    </div>
</template>

<script>

import axios from 'axios';

export default {
    props: {
        bid: {
            type: Object,
            required: false,
        },
        bid_completed: null,
    },
    data() {
        return {
            comments: ''
        };
    },
    methods: {
        storeUserAvaliation() {

            let performance_val = document.querySelectorAll('li.ativo.desempenho')[0].getAttribute('data-aval-desem');
            let service_val = document.querySelectorAll('li.ativo.atendimento')[0].getAttribute('data-aval-atend');
            let delivery_val = document.querySelectorAll('li.ativo.prazo')[0].getAttribute('data-aval-prazo');

            const data = {
                performance: performance_val,
                service: service_val,
                delivery_time: delivery_val,
                comments: this.comments,
                bid_id: this.bid.id,
                bid_completed: this.bid_completed
            }

            axios.post('/evaluate/expert', data)
            .then(response=>{
                window.location.reload();
            }).catch(error=>{
            });

        },
        avaliation(e) {

            var stars = e.target.parentElement.getElementsByClassName('star-icon');
            stars = Array.from(stars);

            var classStar = e.target.classList;
            
            if(!classStar.contains('ativo') && classStar.contains('star-icon')){
                stars.forEach(function(star){
                    star.classList.remove('ativo');  
                });
            
                classStar.add('ativo'); 
            }
        },
    }
}
</script>
<style>

    .margin-t {
        margin-top: 12px;
    }

    .none-padding {
        padding: 0px;
    }

    .padding-x {
        padding-left: 15px;
        padding-right: 15px;
    }

    .star-icon {
        list-style-type: none;
        border: 1px solid #fff;
        cursor: pointer;
        color: #ffe500;
        font-size: 20px;

    }

    .star-icon::before {
        content: "\2605";
    }

    .star-icon.ativo ~ .star-icon::before {
        content: "\2606";
    }

    .avaliacao:hover .star-icon::before {
        content: "\2605";
    }

    .star-icon:hover ~ .star-icon::before {
        content: "\2606";
    }

    .avaliacao {
        display: flex;
        padding-left: 0px;
        width: 90px;
    }

</style>